<div class="color-contrast-dialog">
  <!-- BOX: CHỌN MÀU CHỮ/MÀU BIỂU TƯỢNG -->
  <div class="title-box">
    <!-- Tiêu đề -->
    <h2 class="title-container">{{'phan_tich_do_tuong_phan_mau' | translate}}</h2>
    
    <!-- Icon close -->
    <mat-icon *ngIf="data?.hasOwnProperty('colorContrast')" class="close-icon" (click)="close()">
      close
    </mat-icon>
  </div>
  <div class="select-box">
    <!-- Tiêu đề box -->
    <h3 class="title">{{ 'mau_chu_dao' | translate }}</h3>

    <!-- Lựa chọn màu chủ đạo của chữ hay nền -->
    <select [(ngModel)]="mainColorType" (ngModelChange)="suggestedColors = getSuggestedColors()">
      <option [value]="'text_or_icon_color'">
        {{ 
          (
            data?.hasOwnProperty('colorContrast') 
            ? (data.colorContrast.typeFgColor == 'text' ? 'mau_chu' : 'mau_bieu_tuong') 
            : 'mau_chu_mau_bieu_tuong'
          ) | translate 
        }}
      </option>
      <option [value]="'bg_color'">{{ 'mau_nen' | translate }}</option>
    </select>
  </div>
  <div class="color-box">
    <!-- Tiêu đề box -->
    <h3 class="title">
      {{ 
        (
          data?.hasOwnProperty('colorContrast') 
          ? (data.colorContrast.typeFgColor == 'text' ? 'mau_chu' : 'mau_bieu_tuong') 
          : 'mau_chu_mau_bieu_tuong'
        ) | translate 
      }}
    </h3>
    <div class="row-dialog">
      <!-- Nhập mã màu HEX -->
      <div>
        <label>Hex:</label>
        <input [(ngModel)]="fgHex" (change)="onHexChange('fg')" maxlength="7" />
      </div>
      <!-- Nhập rgb -->
      <div>
        <label>RGB:</label>
        <input [(ngModel)]="fgRgb" (change)="onRgbChange('fg')" maxlength="14" />
      </div>
      <!-- Chọn màu -->
      <div>
        <label>{{'mau' | translate}}:</label>
        <input 
          class="input-color" 
          type="button" 
          [cpOKButton]="true" 
          [(colorPicker)]="fgHex" 
          [style.background]="fgHex" 
          [cpWidth]="'230px'" 
          (colorPickerClose)="onPickerChange('fg')"
          [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
          [cpAddColorButton]="true"
          [cpAddColorButtonText]="'them_mau' | translate"
          [cpPresetLabel]="'bang_mau_mau' | translate"
          [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
          [cpPresetColors]="themeService.themeColors"
          (cpPresetColorsChange)="themeService.presetColorsChange($event)"
        />
      </div>
      <!-- Box chọn màu -->
      <div>
        <label>{{'ten_mau' | translate}}:</label>
        <select [ngModel]="getColorName('fg')" (ngModelChange)="setColor($event, 'fg')">
          <option *ngFor="let c of colorList" [value]="c.name"
          [style.background]="c.hex" [style.color]="c.color">
            {{c.name}}
          </option>
        </select>
      </div>
    </div>
    <!-- Chỉnh độ sáng -->
    <div class="slider-row-dialog">
      <label>{{'dieu_chinh_do_sang' | translate}}: {{fgLightness}}%</label>
      <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
        [(ngModel)]="fgLightness"
        (ngModelChange)="setLightness($event, 'fg')"
        [nzTooltipVisible]="'never'"
        class="brightness-slider brightness-fg-slider"
        [style.--fg-slider-gradient]="'linear-gradient(to right, #000, ' + fgOriginColor + ' 50%, #fff)'"
      ></nz-slider>
    </div>
    <!-- Màu gợi ý: Có tỷ lệ tương phản đạt tiêu chuẩn WCAG -->
    <div *ngIf="mainColorType == 'bg_color' && suggestedColors.length" class="suggested-colors mt-4">
      <button
        *ngFor="let item of suggestedColors"
        class="suggested-colors__item"
        (click)="onClickSuggestedColors(item, 'fg')"
        [style.background]="item.hex"
        [class.active]="item.hex == fgHex"
        [matTooltip]="item.hex"
      ></button>
    </div>
  </div>

  <!-- BOX: CHỌN MÀU NỀN -->
  <div class="color-box">
    <!-- Tiêu đề box -->
    <h3 class="title">{{'mau_nen' | translate}}</h3>
    <div class="row-dialog">
      <!-- Nhập mã màu HEX -->
      <div>
        <label>Hex:</label>
        <input [(ngModel)]="bgHex" (change)="onHexChange('bg')" maxlength="7" />
      </div>
      <!-- Nhập rgb -->
      <div>
        <label>RGB:</label>
        <input [(ngModel)]="bgRgb" (change)="onRgbChange('bg')" maxlength="14" />
      </div>
      <!-- Chọn màu -->
      <div>
        <label>{{'mau' | translate}}:</label>
        <input 
          class="input-color" 
          type="button" 
          [cpOKButton]="true" 
          [(colorPicker)]="bgHex" 
          [style.background]="bgHex" 
          [cpWidth]="'230px'" 
          (colorPickerClose)="onPickerChange('bg')"
          [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
          [cpAddColorButton]="true"
          [cpAddColorButtonText]="'them_mau' | translate"
          [cpPresetLabel]="'bang_mau_mau' | translate"
          [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
          [cpPresetColors]="themeService.themeColors"
          (cpPresetColorsChange)="themeService.presetColorsChange($event)"
        />
      </div>
      <!-- Box chọn màu -->
      <div>
        <label>{{'ten_mau' | translate}}:</label>
        <select [ngModel]="getColorName('bg')" (ngModelChange)="setColor($event, 'bg')">
          <option *ngFor="let c of colorList" [value]="c.name"
          [style.background]="c.hex" [style.color]="c.color">
            {{c.name}}
          </option>
        </select>
      </div>
    </div>
    <!-- Chỉnh độ sáng -->
    <div class="slider-row-dialog">
      <label>{{'dieu_chinh_do_sang' | translate}}: {{bgLightness}}%</label>
      <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
        [(ngModel)]="bgLightness"
        (ngModelChange)="setLightness($event, 'bg')"
        [nzTooltipVisible]="'never'"
        class="brightness-slider brightness-bg-slider"
        [style.--bg-slider-gradient]="'linear-gradient(to right, #000, ' + bgOriginColor + ' 50%, #fff)'"
      ></nz-slider>
    </div>
    <!-- Màu gợi ý: Có tỷ lệ tương phản đạt tiêu chuẩn WCAG -->
    <div *ngIf="mainColorType == 'text_or_icon_color' && suggestedColors.length" class="suggested-colors mt-4">
      <button
        *ngFor="let item of suggestedColors"
        class="suggested-colors__item"
        (click)="onClickSuggestedColors(item, 'bg')"
        [style.background]="item.hex"
        [class.active]="item.hex == bgHex"
        [matTooltip]="item.hex"
      ></button>
    </div>
  </div>

  <!-- BOX: kẾT QUẢ -->
  <div class="result-box">
    <!-- Tiêu đề box -->
    <h3 class="title">{{'ket_qua' | translate}}</h3>
    <!-- Mẫu để xem khi đổi màu -->
    <div class="sample-text" [style.background]="bgHex" [style.color]="fgHex">
      <span style="font-size: 1rem;">Small sample text.</span>
      <br>
      <span style="font-size: 2rem;">Large sample text.</span>
    </div>
    <!-- Tỷ lệ tương phản -->
    <div class="contrast-ratio my-3">
      <b>
        {{'ty_le_tuong_phan' | translate}} = {{getContrastRatio()}} : 1 
        <span [style.color]="getContrastRatio() >= 4.5 ? 'green' : 'red'">
          &#8658; {{'lon_hon_hoac_bang_4.5_la_DAT' | translate}}
        </span>
      </b>
    </div>
    <!-- Bảng đánh giá độ tương phản có đạt hay không đạt -->
    <table class="wcag-table">
      <tr>
        <th style="width: 20%">{{'tieu_chuan_wcag' | translate}}</th>
        <th style="width: 30%">{{'van_ban_nho' | translate}}</th>
        <th>{{'van_ban_lon_icon_thanh_phan_ui_va_doi_tuong_do_hoa' | translate}}</th>
      </tr>
      <tr *ngFor="let item of levelsWCAG">
        <td style="font-weight: 600" [matTooltip]="item.tooltip | translate">
          {{item.key}} <i class="bi bi-question-square"></i>
        </td>
        <td class="fail" [ngClass]="{'pass': getWCAGResults()[item.key + '_small']}">
          {{(getWCAGResults()[item.key + '_small'] ? 'dat' : 'khong_dat') | translate}}
        </td>
        <td class="fail" [ngClass]="{'pass': getWCAGResults()[item.key + '_large']}">
          {{(getWCAGResults()[item.key + '_large'] ? 'dat' : 'khong_dat') | translate}}
        </td>
      </tr>
    </table>
  </div>
</div>
